import { suiteReturnPath } from './suiteAuthFlow.ts';
export function crmReturnPath(value: unknown): string {
  return suiteReturnPath(value, '/');
}
